import { BookingWizard } from "../../../../../types";

type Props = {
  rounds: BookingWizard.BaseRound[];
  isRequestBooking: boolean;
  currentRequestGroupIndex: number;
};

export function getExcludedPlayerIds({
  rounds,
  isRequestBooking,
  currentRequestGroupIndex,
}: Props): string[] {
  return rounds
    .filter(
      (round) =>
        isRequestBooking &&
        (round.bookingIndex ?? 0) !== currentRequestGroupIndex
    )
    .flatMap((round) => (round.player.id ? [round.player.id] : []));
}
